<template>
  <div>
    <div class="bottom-wrap">
      <div class="tabbar">
        <div class="item" :class="current == 0 ? 'active' : ''" @click="haddleClick(0)">
          <div class="icon">
            <img
              v-if="current == 0"
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/tab-icon-1-active.png"
            />
            <img
              v-else
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/tab-icon-1-default.png"
            />
          </div>
          <div class="label">领取详情</div>
        </div>
        <div class="item" :class="current == 1 ? 'active' : ''" @click="haddleClick(1)">
          <div class="icon">
            <img
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/tab-icon-2-active-v2.png"
            />
          </div>
          <div class="label">兑换码领取</div>
        </div>
        <div class="item" :class="current == 2 ? 'active' : ''" @click="haddleClick(2)">
          <div class="icon">
            <img
              v-if="current == 2"
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/tab-icon-3-active.png"
            />
            <img
              v-else
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/tab-icon-3-default.png"
            />
          </div>
          <div class="label">开奖公告</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabbarComponent',
  props: {
    current: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {}
  },

  created() {},
  methods: {
    haddleClick(index) {
      const route = this.$route.name
      console.log('this.$route', this.$route)
      const { ver_no } = this.$route.query
      let query_str = ''
      if (ver_no) {
        query_str = `?ver_no=${ver_no}`
      }
      if (index == 0) {
        if (route == 'shopLottery') return
        this.$router.replace('/lottery/shop' + query_str)
      } else if (index == 1) {
        if (route == 'exchangeLottery') return
        this.$router.replace('/lottery/exchange' + query_str)
      } else if (index == 2) {
        if (route == 'noticeLottery') return
        this.$router.replace('/lottery/notice' + query_str)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-wrap {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 6rpx 32rpx 76rpx;
  background: #fff;
  box-shadow: 0 -10px 20px 0 #3537380a;
}

.tabbar {
  width: 100%;
  display: flex;

  .item {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: baseline;
    text-align: center;

    .icon {
      width: 48rpx;
      height: 48rpx;
      margin-bottom: 4rpx;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .label {
      color: #a1a7ad;
      font-size: 24rpx;
      line-height: 36rpx;
    }

    &.active {
      .label {
        color: #ee515f;
      }
    }

    &:nth-child(2) {
      .icon {
        width: 96rpx;
        height: 96rpx;
        margin-top: -48rpx;
        margin-bottom: 4rpx;
      }
    }
  }
}
</style>
